// @flow

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import pick from 'lodash/pick';
import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';

import {
  getTrekPreference,
  updateTrekPreference,
  saveTrekPreference,
} from '../../../../redux/actions/trekPreferenceActions';
import { closeOverviewModal } from '../../../../redux/actions/trekOverviewActions';

import PrefernceItem from './PreferenceItem';
import SmallLoadingWrapper from '../../../Loading/SmallLoadingWrapper';
import EditHandler from './EditHandler';

import { roundOff } from '../../../../lib/utils';

import './preferences.css';

type Props = {
  trekId: string,
  trekDays: number,
  isGuided: boolean,
  isGuidedOwner: boolean,
  getTrekPreference: Function,
  updateTrekPreference: Function,
  saveTrekPreference: Function,
  closeOverviewModal: Function,
  preferences: Array<Object>,
};

type State = {
  prefs: Array<Object>,
  is_updating: boolean,
  is_saving: boolean,
  updateCount: number,
};

class PreferenceList extends Component<Props, State> {
  state = {
    prefs: this.props.preferences || [],
    is_updating: false,
    is_saving: false,
    updateCount: 0,
  };

  render() {
    const { is_updating, is_saving, prefs } = this.state;
    const { isGuidedOwner } = this.props;
    return (
      <div className="service-wrap">
        <div className="service-head">
          <h3 className="title">
            Select Inclusions/Preferences{' '}
            <span onClick={this.closeModal}>
              <i className="icon icon-hg-cross" />
            </span>
          </h3>
        </div>
        <div className="service-body">
          <SmallLoadingWrapper showLoading={prefs.length === 0}>
            {!isGuidedOwner && this.renderTotalAndButton()}
            {this.renderPrefsList()}
            {!isGuidedOwner && this.renderTotalAndButton()}
          </SmallLoadingWrapper>
        </div>
        {isGuidedOwner && (
          <div className="service-foot">
            <div className="text-center">
              <Button
                disabled={is_updating}
                className={is_saving ? 'btn-loading' : ''}
                color="primary "
                onClick={this.savePreference}
              >
                {is_saving ? 'Saving' : 'Save'}
              </Button>{' '}
            </div>
          </div>
        )}
      </div>
    );
  }

  closeModal = () => {
    if (this.state.updateCount > 0)
      this.props.getTrekPreference({ trekId: this.props.trekId });

    this.props.closeOverviewModal();
  };

  renderPrefsList = () => {
    const { isGuided } = this.props;
    const { prefs } = this.state;
    const orderedPrefs = orderBy(prefs, 'order', 'asc');
    return (
      <EditHandler editAction={this.updateTrekPreference}>
        {({ handleEdit }) => (
          <Fragment>
            {orderedPrefs.map(pref => (
              <PrefernceItem
                key={pref.name}
                {...pref}
                prefCost={this.getPrefCost(pref)}
                updatePref={handleEdit}
                isGuided={isGuided}
              />
            ))}
          </Fragment>
        )}
      </EditHandler>
    );
  };

  renderTotalAndButton = () => {
    const { is_updating } = this.state;
    return (
      <div className="top collapse-holder">
        <div className="collapse-head">
          <div className="item" />
          <div className="item">
            <span className="head" style={{ opacity: is_updating ? '0.5' : '1' }}>
              TOTAL: <em>USD {roundOff(this.getTotalCost(), 2)}</em>
              {/* <Button
                disabled={is_updating}
                color="primary "
                onClick={() => this.savePreference()}
              >
                Save
              </Button> */}
            </span>

            {/* <span className="head">Price</span> */}
          </div>
          <div className="item" />
        </div>
      </div>
    );
  };

  getTotalCost = () => {
    const { prefs } = this.state;
    let cost = 0;
    prefs.map(pref => {
      const { is_available, charge } = pref;
      let prefCost = 0;
      if (is_available && charge) {
        prefCost = this.getPrefCost(pref);
        cost = cost + prefCost;
      }

      return null;
    });
    return cost;
  };

  getPrefCost = pref => {
    const { trekDays } = this.props;
    const { poster_type, charge, per_day } = pref;
    let prefCost = 0;
    if (charge) {
      prefCost = Number(charge.amount);
      if (per_day) {
        if (poster_type === 'porters') {
          prefCost = prefCost * Number(trekDays - 1);
        }
      }
    }
    return prefCost;
  };

  updateTrekPreference = async ({ name, is_available }) => {
    const { trekId, updateTrekPreference, isGuided } = this.props;
    const { prefs } = this.state;
    this.setState({
      is_updating: true,
    });

    if (isGuided) {
      const newPrefs = cloneDeep(prefs);
      const indexOfValue = prefs.findIndex(v => v.name === name);

      newPrefs[indexOfValue].is_available = is_available;
      this.setState({
        prefs: newPrefs,
      });
    } else {
      const data = await updateTrekPreference({
        trekId,
        name,
        is_available,
      });
      if (data) {
        this.setState({
          prefs: data,
          updateCount: this.state.updateCount + 1,
        });
      }
    }
    this.setState({
      is_updating: false,
    });
  };

  savePreference = async () => {
    const { prefs } = this.state;
    const { saveTrekPreference, trekId, closeOverviewModal } = this.props;
    this.setState({ is_saving: true });
    const prefsArray = prefs.map(pref => pick(pref, ['name', 'is_available']));
    const data = await saveTrekPreference({
      trekId,
      prefsArray,
    });
    if (data) {
      closeOverviewModal();
    }
    this.setState({ is_saving: false });
  };

  // async componentDidMount() {
  //   try {
  //     const data = await this.props.getTrekPreference({
  //       trekId: this.props.trekId,
  //     });
  //     this.setState({
  //       prefs: data,
  //     });
  //   } catch (err) {
  //     console.log(err, 'preference fetch');
  //   }
  // }
}

const mapStateToProps = ({ selectedTrek }) => {
  const isOwner = selectedTrek.trek && selectedTrek.trek.is_owner;
  const isGuided = selectedTrek.trek && selectedTrek.trek.is_guided;

  return {
    trekId: selectedTrek.trek.id,
    trekDays: selectedTrek.trek.itinerary.length || 1,
    preferences: selectedTrek.preferences,
    isOwner,
    isGuided,
    isGuidedOwner: isOwner && isGuided,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateTrekPreference: ({ trekId, name, is_available }) =>
      dispatch(
        updateTrekPreference({
          trekId,
          name,
          is_available,
        })
      ),
    getTrekPreference: ({ trekId }) =>
      dispatch(
        getTrekPreference({
          trekId,
        })
      ),
    closeOverviewModal: () => dispatch(closeOverviewModal()),
    saveTrekPreference: ({ trekId, prefsArray }) =>
      dispatch(
        saveTrekPreference({
          trekId,
          prefsArray,
        })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreferenceList);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Preferences/PreferenceList.jsx